<template>
  <div
    v-if="!isCollapsed"
    class="flex flex-col gap-2 px-4 border-gray-200 align-center justify-center mx-5 mb-5 rounded-xl border shadow-xl"
  >
    <div class="flex flex-col gap-5 align-center flex-1 overflow-y-auto py-8">
      <div
        v-for="(navItem, i) in filteredNavItems"
        :key="i"
        class="flex flex-col align-center gap-1"
      >
        <RouterLink v-if="!navItem.children" :to="navItem.path">
          <avatar class="relative" shape="circle" :image="null">
            <span
              v-if="
                (chatNotifications && navItem.path.includes('/Chat')) ||
                (omniNotifications && navItem.path.includes('/social-media'))
              "
              :class="[
                'absolute top-0 z-10 bg-red text-white text-xs rounded-full w-4 h-4 flex items-center justify-center',
                {
                  'left-0': $i18n.locale === 'ar',
                  'right-0': $i18n.locale !== 'ar',
                },
              ]"
            >
              {{
                chatNotifications && navItem.path.includes("/Chat")
                  ? chatNotifications
                  : omniNotifications
              }}
            </span>
            <v-icon
              size="25"
              :color="
                $route.path.includes(navItem.path)
                  ? 'var(--p-primary-500)'
                  : 'black'
              "
              >{{ navItem.icon }}</v-icon
            >
          </avatar>
        </RouterLink>
        <div v-else class="card flex justify-center">
          <BubbleMenu position="end">
            <template #trigger>
              <button class="menu-trigger">
                <v-icon
                  size="25"
                  :color="
                    isChildActive(navItem) ? 'var(--p-primary-500)' : 'black'
                  "
                  >{{ navItem.icon }}</v-icon
                >
              </button>
            </template>
            <template #default>
              <div class="flex flex-col gap-2">
                <RouterLink
                  :to="child.path"
                  v-for="child in navItem.children"
                  :key="child.path"
                  :class="[
                    'hover:bg-gray-200 p-2',

                    $route.path.includes(child.path) ? 'text-primary-500' : '',
                  ]"
                >
                  <v-icon>{{ child.icon }}</v-icon>
                  {{ $t(`layouts.${child.title}`) }}
                </RouterLink>
              </div>
            </template>
          </BubbleMenu>
          <!-- <Button
            type="button"
            @click="toggleMenu($event, i)"
            aria-haspopup="true"
            aria-controls="overlay_menu"
          >
            <avatar
              shape="circle"
              :class="{
                // 'bg-primary-900': $route.path.includes(navItem.path),
                // 'bg-light-grey': $route.path.includes(navItem.path) === false,
              }"
            >
              <v-icon
                size="25"
                :color="
                  $route.path.includes(navItem.path)
                    ? 'var(--p-primary-500)'
                    : 'black'
                "
                >{{ navItem.icon }}</v-icon
              >
            </avatar>
          </Button>
          <Menu
            :ref="'menu_' + i"
            :model="formatChildMenuItems(navItem.children)"
            :popup="true"
            :id="'overlay_menu_' + i"
            :pt="{
              root: {
                dir: 'ltr',
              },
            }"
          /> -->
        </div>
      </div>
    </div>
    <floating-dialer
      v-if="userHasPermisson(permissions, phonePermission)"
      class="flex justify-center"
    />
    <Button
      class="rounded-full p-2 hover:!bg-gray-200 text-black"
      @click="changeLocale(currentLocal == 'en' ? 'ar' : 'en')"
    >
      <v-icon>{{ "mdi-earth" }}</v-icon>
    </Button>
    <Button
      class="bg-white text-red rounded-full p-2 hover:!bg-red-50 mb-6 border"
      @click="logoutUser"
    >
      <v-icon>{{ "mdi-power" }}</v-icon>
    </Button>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { Avatar, Button } from "primevue";
import Swal from "sweetalert2";
import BubbleMenu from "@/components/BubbleMenu.vue";
import FloatingDialer from "@/pages/call/components/FloatingDialer.vue";
export default {
  name: "NavBar",
  components: {
    Avatar,
    Button,
    BubbleMenu,
    FloatingDialer,
  },
  computed: {
    ...mapGetters([
      "navigationsMenu",
      "permissions",
      "notReadChatMessages",
      "notReadOmniMessages",
      "smsPermission",
      "getbaseURL",
      "isCollapsed",
      "phonePermission",
    ]),
    filteredNavItems() {
      return this.navigationsMenu
        .filter(
          (item) =>
            !item.hide &&
            this.userHasPermisson(this.permissions, item.permission)
        )
        .map((item) => {
          // Only process children if the parent is visible
          if (item.children) {
            const visibleChildren = item.children.filter(
              (child) =>
                !child.hide &&
                this.userHasPermisson(
                  this.permissions,
                  child.permission || item.permission
                )
            );

            // Only return item with children if there are visible children
            if (visibleChildren.length > 0) {
              return { ...item, children: visibleChildren };
            }
            return null; // Skip this item if no visible children
          }
          return item;
        })
        .filter((item) => item !== null); // Remove null entries
    },

    logo() {
      return require("../assets/diwan.png");
    },

    chatNotifications() {
      return this.notReadChatMessages?.length > 0
        ? this.notReadChatMessages.length.toString()
        : "";
    },

    omniNotifications() {
      return this.notReadOmniMessages?.length > 0
        ? this.notReadOmniMessages.length.toString()
        : "";
    },
    currentLocal() {
      return this.$vuetify.locale.current;
    },
  },
  methods: {
    ...mapActions(["logout"]),
    ...mapMutations(["setLang"]),
    hasPermisson(permission) {
      if (!this.permissions) {
        return false;
      }
      return this.permissions.includes(permission);
    },
    changeLocale(locale) {
      const html = document.documentElement;
      html.dir = locale === "ar" ? "rtl" : "ltr";
      this.$vuetify.locale.current = locale;
      this.setLang(locale);
    },

    toggleMenu(event, index) {
      this.$refs[`menu_${index}`][0].toggle(event);
    },

    isChildActive(navItem) {
      if (!navItem.children) return false;
      return navItem.children.some((child) =>
        this.$route.path.includes(child.path)
      );
    },

    transformChildrenForMenu(children) {
      if (!children) return [];

      return children.map((child) => ({
        label: this.$t(`layouts.${child.title}`),
        icon: this.getIconClass(child.icon, child.title), // Transform icon format
        to: child.path,
        command: () => {
          this.$router.push(child.path);
        },
      }));
    },
    formatChildMenuItems(children) {
      if (!children) return [];

      return children.map((child) => ({
        label: this.$t(`layouts.${child.title}`),
        icon: child.icon, // Directly use the MDI icon class
        to: child.path,
        command: () => this.$router.push(child.path),
        template: (item, options) => {
          return `<a class="${options.className}" href="${options.url}" target="${options.target}">
              <span class="p-menuitem-icon ${item.icon}"></span>
              <span class="p-menuitem-text">${item.label}</span>
            </a>`;
        },
      }));
    },

    // Helper method to transform icon format
    getIconClass(icon, title) {
      console.log("My cheild info", title, icon);

      if (!icon) return "";

      // If it's already in the correct format, return as-is
      if (icon.startsWith("pi-") || icon.startsWith("mdi-")) {
        return icon;
      }

      // Convert Material Design Icons format if needed
      if (icon.startsWith("mdi")) {
        return icon.replace("mdi-", "pi-"); // Adjust based on your icon library
      }

      // Default case - prefix with 'pi-' for PrimeIcons
      return `pi-${icon}`;
    },

    logoutUser() {
      Swal.fire({
        title: this.$t("layouts.logout"),
        text: this.$t("layouts.logout_text"),
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "!bg-primary-500 text-white",
          cancelButton: "!bg-gray-500 text-white",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.logout();
        }
      });
    },
    handleMenuAction(item) {
      console.log("My item", item);
      this.$router.push(item.to);
    },
  },
};
</script>
<style scoped>
/* RTL menu positioning */
.rtl-menu.p-menu-overlay {
  right: 0;
  left: auto !important;
  transform-origin: right top;
}

/* RTL menu items layout */
.rtl-menu .p-menuitem-content {
  flex-direction: row-reverse;
  justify-content: flex-end;
}

/* Adjust icon positioning for RTL */
.rtl-menu .p-menuitem-icon {
  margin-left: 0.5rem;
  margin-right: 0 !important;
}

.rtl-menu-popup {
  right: 0 !important;
  left: auto !important;
  transform-origin: right top;
}
</style>
